import fromUnixTime from 'date-fns/fromUnixTime';

/**
 * @deprecated Use `new dateHelpers(1661065200000)` class instead
 * @param {number} timestamp
 */
export const getDateFromUnixTime = (timestamp: number): Date => fromUnixTime(timestamp);

export default getDateFromUnixTime;
